import { getPendingActionData } from '../api';

const services = (dispatch, actions) => ({
  getPendingActions: (payload) => {
    dispatch(actions.myaccountActions('DATA_LOADING', { loading_actions: true }));
    getPendingActionData(payload)
      .then((res) => {
        dispatch(actions.myaccountActions('GET_PENDING_ACTIONS', res.data));
      })
      .catch((err) => {
        console.log(err);
      });
  },
});

export default services;
